const PROTOCOL_API_LEVEL = {
  date: '1.0',
  week: '1.0',
  battery: '1.0',
  step: '1.0',
  calorie: '1.0',
  heart_rate: '1.0',
  pai: '1.0',
  pai_daily: '1.0',
  distance: '1.0',
  stand: '1.0',
  weather: '1.0',
  temperature: '1.0',
  uvi: '1.0',
  aqi: '1.0',
  humidity: '1.0',
  sun: '1.0',
  wind: '1.0',
  stress: '1.0',
  spo2: '1.0',
  altimeter: '1.0',
  training_load: '1.0',
  vo2max: '1.0',
  recovery_time: '1.0',
  sleep: '1.0',
  floor: '1.0',
  moon: '1.0',
  moon_rise: '2.0',
  moon_set: '2.0',
  altitude: '2.0',
  month_run_times: '2.1',
  month_run_distance: '2.1',
  hrv: '4.0',
  bio_charge: '4.2',
  lthr: '4.4',
  ltpace: '4.4'
}

export default PROTOCOL_API_LEVEL
